import {
  Field,
  ID,
  InputAndObjectType,
} from '@warebee/shared/util-backend-only-types';
import {
  AssignmentCapacityPolicy,
  AssignmentPolicy,
  LocationSharingPolicy,
  PickingPolicy,
  ProximityPolicy,
  ResourcePolicy,
  RoutingPolicy,
  StackingPolicy,
  WaypointPolicy,
} from './policies';

@InputAndObjectType()
export class ActualityEmployeeShiftSettings {
  @Field({ nullable: true })
  shiftDetectionOffsetSeconds?: number;
}

@InputAndObjectType()
export class ActualitySettings {
  @Field(() => ActualityEmployeeShiftSettings, { nullable: true })
  employeeShiftSettings?: ActualityEmployeeShiftSettings;
}

@InputAndObjectType()
export class ActualitySnapshot {
  @Field(() => ID, { nullable: true })
  layoutId?: string;

  @Field(() => ID, { nullable: true })
  activityFeedId?: string;

  @Field(() => ID, { nullable: true })
  itemSetId?: string;

  @Field(() => ID, { nullable: true })
  assignmentId?: string;

  @Field(() => ID, { nullable: true })
  orderSetId?: string;

  @Field(() => ID, { nullable: true })
  inventorySnapshotId?: string;

  @Field(() => AssignmentPolicy, { nullable: true })
  assignmentPolicy?: AssignmentPolicy;

  @Field(() => ProximityPolicy, { nullable: true })
  proximityPolicy?: ProximityPolicy;

  @Field(() => ResourcePolicy, { nullable: true })
  resourcePolicy?: ResourcePolicy;

  @Field(() => PickingPolicy, { nullable: true })
  pickingPolicy?: PickingPolicy;

  @Field(() => AssignmentCapacityPolicy, { nullable: true })
  assignmentCapacityPolicy?: AssignmentCapacityPolicy;

  @Field(() => LocationSharingPolicy, { nullable: true })
  locationSharingPolicy?: LocationSharingPolicy;

  @Field(() => RoutingPolicy, { nullable: true })
  routingPolicy?: RoutingPolicy;

  @Field(() => StackingPolicy, { nullable: true })
  stackingPolicy?: StackingPolicy;

  @Field(() => WaypointPolicy, { nullable: true })
  waypointPolicy?: WaypointPolicy;

  @Field(() => ActualitySettings, { nullable: true })
  settings?: ActualitySettings;
}

@InputAndObjectType()
export class BuildActualityPreAggregatedTablesJobInput {
  @Field(() => ID, { nullable: true })
  actualityId?: string;

  @Field(() => ActualitySnapshot, { nullable: true })
  actuality?: ActualitySnapshot;
}
